import { render, staticRenderFns } from "./ActiveOpportunity.vue?vue&type=template&id=14251315&"
import script from "./ActiveOpportunity.vue?vue&type=script&lang=js&"
export * from "./ActiveOpportunity.vue?vue&type=script&lang=js&"
import style0 from "./ActiveOpportunity.vue?vue&type=style&index=0&id=14251315&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports